export type PermissionPayload = {
	readonly value: string;
	readonly label: string;
	readonly description: string;
	readonly category: string;
};

export type UserPermissionsFetchedPayload = PermissionPayload[];

export type UserPermissionsFetchedAction = {
	type: 'USER_PERMISSIONS_FETCHED';
	payload: UserPermissionsFetchedPayload;
};

export default (payload: UserPermissionsFetchedPayload): UserPermissionsFetchedAction => ({
	type: 'USER_PERMISSIONS_FETCHED',
	payload,
});
